import React from "react";
import TeamStandings from "./components/TeamStandings";

function App() {
  return (
    <div className="App">
      <TeamStandings />
    </div>
  );
}

export default App;
